RivalIQ.apps.Shell.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    const Checkbox = views.Checkbox = views.RadioButton.extend({
        attributes: function () {

            const me = this;
            const attributes = views.RadioButton.prototype.attributes.apply(me, arguments);
            return _.extend(attributes, {
                type: 'checkbox'
            });
        }
    });

    /**
     * Gets item view options from a configuration.
     * @param {Object} config The configuration.
     * @returns {Object} An object representing view options.
     */
    Checkbox.getItemViewOptionsFromConfig = function (config) {

        return _.pick(config, 'name', 'model');
    };

});
